import React from 'react';
import PropTypes from 'prop-types';
import { isCurrentDay, pushHours } from '../../helpers/timeHelpers';
import * as Styled from './OpeningHours.styles';

var formatHours = function formatHours(day) {
  var times = day.time.split(' - ');
  return {
    shortDay: day.date.substring(0, 3),
    longDay: day.date,
    opening: times[0],
    closing: times[1]
  };
};

var OpeningHoursDay = function OpeningHoursDay(_ref) {
  var day = _ref.day,
      opening = _ref.opening,
      closing = _ref.closing,
      longDay = _ref.longDay,
      _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active;
  return /*#__PURE__*/React.createElement(Styled.OpeningHoursListItem, null, /*#__PURE__*/React.createElement(Styled.OpeningHoursWrapperSpan, {
    active: active
  }, /*#__PURE__*/React.createElement(Styled.OpeningHoursDaySpan, {
    "aria-label": longDay
  }, day), /*#__PURE__*/React.createElement(Styled.OpeningHoursTimeWrapper, null, /*#__PURE__*/React.createElement(Styled.OpeningHoursTimeStartSpan, {
    "aria-label": "Opens at ".concat(opening)
  }, opening), /*#__PURE__*/React.createElement(Styled.OpeningHoursTimeSpacerSpan, null, " - "), /*#__PURE__*/React.createElement(Styled.OpeningHoursTimeEndSpan, {
    "aria-label": "Closes at ".concat(closing)
  }, closing))), /*#__PURE__*/React.createElement("span", {
    hidden: true,
    itemProp: "openingHours",
    dateTime: "".concat(day, " ").concat(opening, " - ").concat(closing)
  }, "".concat(day, " ").concat(opening, " - ").concat(closing)));
};

OpeningHoursDay.propTypes = {
  day: PropTypes.string,
  opening: PropTypes.string,
  closing: PropTypes.string,
  longDay: PropTypes.string,
  active: PropTypes.bool
};

var OpeningHours = function OpeningHours(_ref2) {
  var _ref2$highlightCurren = _ref2.highlightCurrentDay,
      highlightCurrentDay = _ref2$highlightCurren === void 0 ? true : _ref2$highlightCurren,
      _ref2$hours = _ref2.hours,
      hours = _ref2$hours === void 0 ? [] : _ref2$hours;
  if (hours.length === 0) return null;
  var formattedHours = pushHours(hours).map(formatHours);
  return /*#__PURE__*/React.createElement(Styled.OpeningHoursWrapper, null, /*#__PURE__*/React.createElement(Styled.OpeningHoursTitleSrOnly, null, "Our opening hours..."), /*#__PURE__*/React.createElement(Styled.OpeningHoursList, null, formattedHours.map(function (day) {
    return /*#__PURE__*/React.createElement(OpeningHoursDay, {
      day: day.shortDay,
      opening: day.opening,
      closing: day.closing,
      longDay: day.longDay,
      active: highlightCurrentDay && isCurrentDay(day.longDay),
      key: day.shortDay
    });
  })));
};

OpeningHours.propTypes = {
  highlightCurrentDay: PropTypes.bool,
  hours: PropTypes.array
};
export { OpeningHoursDay };
export default OpeningHours;